// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"a029a1aa","78":"ac070ee2","93":"f92cf652","220":"a01e6bd5","274":"4c3f16cb","714":"c5c60939","718":"e6dd7972","944":"ab5f75c6"}[chunkId] + ".chunk.js";
};